import script from "./FloatingSideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingSideNav.vue?vue&type=script&setup=true&lang=js"

import "./FloatingSideNav.vue?vue&type=style&index=0&id=351f34d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351f34d8"]])

export default __exports__